import { render, staticRenderFns } from "./ProjectDetailDialog.vue?vue&type=template&id=2a09451b&"
import script from "./ProjectDetailDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports